
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import GiftWinner from "@/router/views/gift/gift-winner";

/**
 * Reporting component
 */
export default {
  page: {
    title: "SettingsMenu",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, GiftWinner},

};
</script>

<template>
  <Layout>
    <div class="px-3">
      <GiftWinner/>
    </div>
  </Layout>
</template>
